import React, { SyntheticEvent } from 'react'
import {
  Box, BoxProps, Button, Typography, useTheme
} from '@mui/material'
import { Link as GatsbyLink } from 'gatsby'

import { getIcon, Icon } from '@components/Icon'

type CalloutProps = {
  link: string
  icon?: string
  title: string
  buttonContained?: boolean
  buttonText: string
  onClick?: (e: SyntheticEvent) => void
}

export const Callout = ({
  link, icon, title, buttonContained, buttonText, onClick, ...boxProps
}: CalloutProps & BoxProps) => {
  const {palette} = useTheme()
  return (
    <Box
      onClick={onClick}
      component={link.startsWith('http') ? 'a' : GatsbyLink}
      {...{
        [link.startsWith('http') ? 'href' : 'to']: link
      }}
      {...boxProps}
      sx={{
        cursor: 'pointer',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        borderRadius: 2,
        p: 3,
        py: {
          xs: 2,
          tablet: 3
        },
        bgcolor: 'primaryBg.main',
        mx: {
          xs: 1,
          mobile: 3,
          tablet: 0
        },
        transition: 'background .2s linear',
        '&:hover': {
          backgroundColor: palette.primaryBg.dark
        },
        ...boxProps.sx
      }}>
      {icon && <Icon sx={{ mr: 3, fontSize: '24px' }} icon={getIcon(icon)} />}
      <Typography
        variant="h6"
        sx={{
          lineHeight: 1.2,
        }}>
        {title}
      </Typography>
      <Button
        variant={buttonContained ? 'contained' : 'text'}
        sx={{
          lineHeight: 1,
          flexBasis: {
            xs: '100%',
            tablet: 'inherit'
          },
          ml: {
            xs: -1,
            tablet: 'auto',
          },
          mr: {
            xs: -1,
            tablet: 0
          },
          mt: {
            xs: 1,
            tablet: 0
          },
          justifyContent: 'space-between',
          textAlign: 'left'
        }}
      >
        {buttonText}
        {!buttonContained && <Icon sx={{ ml: 2 }} icon="arrow-right" />}
      </Button>
    </Box>
  )
}